// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Footer = require("../components/footers/Footer.bs.js");
let Header = require("../components/headers/Header.bs.js");
let Loader = require("../uikit/reason/atoms/Loader/Loader.bs.js");
let TopNav = require("./TopNav.bs.js");
let Particles = require("../uikit/reason/Styles/Particles.bs.js");
let MediaQuery = require("../reason/common/Media/MediaQuery.bs.js");
let AuthSession = require("../utils/AuthSession.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let UseNewVersionNotice = require("../reason/newVersionNotice/UseNewVersionNotice.bs.js");
let SystemMessageDisplay = require("../reason/systemMessages/SystemMessageDisplay.bs.js");
let ClientAuthorizationCheck = require("../reason/common/ClientAuthorizationCheck/ClientAuthorizationCheck.bs.js");

function MainApp(props) {
  let match = React.useState(() => false);
  let setTopNavIsOpened = match[1];
  let topNavIsOpened = match[0];
  UseNewVersionNotice.useNewVersionNotice();
  ClientAuthorizationCheck.use();
  let authSession = AuthSession.use();
  let mobileNavToggle = param => setTopNavIsOpened(v => !v);
  let body = authSession !== undefined && authSession.__typename !== "AuthSessionInitializing" ? props.children : JsxRuntime.jsx(Loader.make, {
      flexGrow: true
    });
  let mobileNav = topNavIsOpened ? JsxRuntime.jsx(TopNav.make, {
      mobileNavToggle: mobileNavToggle
    }) : null;
  let tmp;
  if (authSession !== undefined) {
    switch (authSession.__typename) {
      case "AuthSession" :
      case "AuthSessionUnauthenticated" :
        tmp = true;
        break;
      case "AuthSessionInitializing" :
      case "__unselected" :
        tmp = false;
        break;
    }
  } else {
    tmp = false;
  }
  let tmp$1;
  if (authSession !== undefined && authSession.__typename === "AuthSession") {
    let tmp$2;
    tmp$2 = authSession.user.role === "AGENT" ? "agent" : "client";
    tmp$1 = tmp$2;
  } else {
    tmp$1 = undefined;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Header.make, {
        isLoggedIn: tmp,
        userRole: tmp$1,
        handleSignout: () => {
          AuthSession.logout();
        },
        mobileNavToggle: mobileNavToggle,
        topNavIsOpened: topNavIsOpened
      }),
      JsxRuntime.jsx(MediaQuery.make, {
        query: {
          TAG: "MinWidth",
          _0: Particles.Breakpoint.ofString("545px")
        },
        children: JsxRuntime.jsx(TopNav.make, {
          mobileNavToggle: mobileNavToggle
        })
      }),
      JsxRuntime.jsx(MediaQuery.make, {
        query: {
          TAG: "MaxWidth",
          _0: Particles.Breakpoint.ofString("544px")
        },
        children: mobileNav
      }),
      JsxRuntime.jsx(SystemMessageDisplay.make, {}),
      body,
      JsxRuntime.jsx(Footer.make, {})
    ],
    className: "min-h-screen bg-zinc-100 flex flex-col"
  });
}

let make = MainApp;

exports.make = make;
/* react Not a pure module */
